const SettingsRoutes = {
  appSettings: "/settings",
  updateAppSettings: "/settings/update",
  allStats: "/stats",
}

export default SettingsRoutes